import { loggerInstance } from "../../utils/hiver-logs";

export default {
  methods: {
    async handleChatbotFlowOnNewConversation(
      campaignId = null,
      triggerType = 'widget',
      createConversation = false,
      contactData = null,
    ) {
      if (!this.hasAConnectedAgentBot) return;

      try {
         this.$store.dispatch('conversationAttributes/setConversationload', true);
         loggerInstance.addLog({ name: loggerInstance.EVENTS.NEW_CONVERSATION_BOT, type: 'event' });
         if (createConversation) {
           this.$store.dispatch('conversation/createConversation', {}).then((resp) => {
               return this.registerChatsbotService({
                 conversationId: resp.id,
                 inboxId: resp.inbox_id,
                 triggerType,
                 nudgeId: campaignId
               });
             });
             return;
         }

         await this.sendMessage({
           content: ''
         }).then(resp => {
           const { conversation_id, inbox_id } = resp.data;
           if (contactData) {
               this.$store.dispatch('contacts/update', { user: {...contactData}});
           }
           return this.registerChatsbotService({
             conversationId: conversation_id,
             inboxId: inbox_id,
             triggerType,
             nudgeId: campaignId
           });
         });
      }
      finally{
        this.$store.dispatch('conversationAttributes/setConversationload', false);
      }
    }
  }
};
